import { styled } from '@mui/material/styles'
import { Paper, Box, Toolbar } from '@mui/material'

interface PrintContentProps {
  orientation?: string
}

export const StyledPrintContent = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'orientation',
})<PrintContentProps>(({ theme, orientation }) => ({
  width: orientation === 'landscape' ? '297mm' : '210mm',
  minHeight: orientation === 'landscape' ? '210mm' : '297mm',
  padding: theme.spacing(4),
  backgroundColor: 'white',
  margin: '0 auto',
  transition: 'width 0.3s, min-height 0.3s',
  boxSizing: 'border-box',
  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  overflow: 'auto',
  '@media print': {
    boxShadow: 'none',
    margin: 0,
    padding: theme.spacing(2),
    width: '100%',
    height: 'auto',
    overflow: 'visible',
  },
}))

export const StyledDialogPaper = styled(Box)(({ theme }) => ({
  height: '90vh',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}))

export const StyledOptionsContainer = styled(Toolbar)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid #eee',
  backgroundColor: '#f5f5f5',
  minHeight: 'auto',
  flexShrink: 0,
}))

export const StyledPreviewContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  overflow: 'auto',
  backgroundColor: '#f5f5f5',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  flexGrow: 1,
  height: 'calc(90vh - 64px)',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#bdbdbd',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f5f5f5',
  },
}))
